import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import { getCurrentInstance, ref, reactive, onMounted } from 'vue'
import Pagination from '@/components/Pagination.vue'
import { getOrderListApi } from '@/apis/couponline'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()

const filters = reactive({
    vender_name: '', // 厂家
    merorderid: '', // 订单号
    account: '', // 手机号
    name: '', // 电子券名称
    type: 1, // 1-查询数据，2-导出数据
    start_time: '', // 开始日期
    end_time: '', // 结束日期
    page: 1,
    page_size: 10,
})

// 初始化列表数据
const total = ref()
const tableData = ref([])
const getList = async () => {
    const { code, data, msg } = await getOrderListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}
const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

// 导出
const onExport = () => {
    const { merorderid, account, name } = filters
    window.open(`${Keys.baseUrl}/couponrecharge/coupon_api/zhichong_order_list?${joinParams({type: 2, merorderid, account, name, user_id: store.state.user.userInfo.id})}`)
}

onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.vender_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.vender_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "厂家",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.merorderid,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.merorderid) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单编号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.account,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.account) = $event)),
        modelModifiers: { trim: true },
        placeholder: "手机号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "电子券名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_time) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_time) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (onExport()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("批量导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "merorderid",
          label: "订单号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "account",
          label: "手机号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "vender_name",
          label: "厂家"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "电子券名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道"
        }),
        _createVNode(_component_el_table_column, {
          prop: "servicetype",
          label: "类型"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.servicetype == 0 ? '直充' : '卡券'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "num",
          label: "数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "retailprice",
          label: "单价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payment_amount",
          label: "支付金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel_amount",
          label: "结算金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})